import axios from "axios";

const baseUrl = process.env.REACT_APP_BACKEND_URL + "api/auth";

const useLogin = () => {
  const login = async (email, password) => {
    try {
      const response = await axios.post(
        `${baseUrl}/login`,
        {
          email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return {
        token: response.data.token,
        user: response.data.user,
      };
    } catch (error) {
      console.error("Error logging in:", error);
      throw error;
    }
  };

  const registerRequest = async (data) => {
    try {
      const response = await axios.post(`${baseUrl}/register-request`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("Register request response:", response);
      return response;
    } catch (error) {
      console.error("Error registering request:", error);
      throw error;
    }
  };

  return {
    login,
    registerRequest,
  };
};

export default useLogin;
